import {Pipe, PipeTransform} from "@angular/core";
import {Month} from "../enums/month";
import {MonthName} from "../enums/month-name";

@Pipe({
  name: 'monthname',
  standalone: true
})
export default class MonthNamePipe implements PipeTransform {
  transform(value: number): string {
    return MonthName[value as Month];
  }
}
